// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1945":"9f4346b4","4509":"c7c6ac2f","9904":"1c976c8e"}[chunkId] + ".chunk.css";
};